/// <reference types="vite/client" />

import { type App, createApp, type DefineComponent } from 'vue'

// This is glue to make it possible to have drop in vue components in the project
// This not in any way shape or form exemplary code.

// TODO phase out this code
const modules: Record<string, { default: DefineComponent }> = import.meta.glob('./**/*.vue', {
  eager: true,
})

const components = Object.fromEntries(
  Object.entries(modules).map(([path, mod]) => {
    // Extract file name (e.g., "MyButton.vue" → "MyButton")
    const name = path.split('/').pop()!.replace('.vue', '')
    return [name, mod.default]
  })
)

const activeFloatingInstances: App<Element>[] = []

/**
 * Finds all elements in the page with the data-vue-component attribute and mounts the names component in place
 */
export function mountFloatingVueInstances() {
  const elements = document.querySelectorAll('[data-vue-component]')
  for (const element of elements) {
    const rootComponentName = element.getAttribute('data-vue-component')
    if (rootComponentName == null || components[rootComponentName] == null) {
      throw new Error(
        `the component ${rootComponentName} was not found in the list of available components`
      )
    }
    const app = createApp(components[rootComponentName])
    activeFloatingInstances.push(app)
    element.__vue = app.mount(element)
  }
}

export function unmountFloatingVueInstances() {
  let app
  while ((app = activeFloatingInstances.pop()) != null) {
    app.unmount()
  }
}
